/**
 * Typography tokens
 * Defines font families, sizes, weights, line heights, and letter spacing
 */

export const typography = {
  // Font families
  fontFamily: {
    primary:
      "'Inter', 'Noto Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
    display: "'Noto Serif', 'Playfair Display', 'Georgia', 'Times New Roman', serif",
    monospace:
      "'JetBrains Mono', 'Fira Code', 'Consolas', 'Monaco', 'Courier New', monospace",
  },

  // Font sizes (px) - Refined scale with better hierarchy
  fontSize: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '30px',
    '4xl': '32px', // Page h1
    'metric': '28px', // Dashboard metric values
    'section': '22px', // Section h2
    'cardHeading': '18px',
    '5xl': '44px', // Increased from 40px
    '6xl': '52px', // Increased from 48px
  },

  // Font weights
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  // Line heights - Refined for better readability
  lineHeight: {
    tight: 1.25, // Headings (improved from 1.2)
    normal: 1.6, // Body text (improved from 1.5)
    relaxed: 1.75, // Long form content (improved from 1.6)
    loose: 2, // Large text blocks
  },

  // Letter spacing - Refined for elegance
  letterSpacing: {
    tighter: '-0.3px', // Large headings (subtle)
    tight: '-0.15px', // Medium headings
    normal: '0', // Body text
    wide: '0.3px', // Uppercase text
    wider: '0.5px', // Large display text
  },
} as const;

export type Typography = typeof typography;
